import styled from "styled-components";
import { Wrapper } from 'AppReact';
import device from 'utils/device';

const buttonTemplate = styled.div`
    width: 336px;
    padding: 0 24px;
    margin: 0 auto;
    display:flex;
    justify-content

    @media ${device.tablet} {
        width: 594px;
    }
`

export default Wrapper(buttonTemplate);
